import { deriveCheckpointsFromTour, ensureLatLng } from './normalizeTourNodes';

const toLatLngOrNull = (value) => {
  if (!value) return null;
  const { lat, lng } = ensureLatLng(value);
  return Number.isFinite(lat) && Number.isFinite(lng) ? { lat, lng } : null;
};

const resolveTourStartLatLng = (tour) => {
  if (!tour) return null;

  const { originNode, checkpoints: derivedCheckpoints } = deriveCheckpointsFromTour(tour);
  const nodes = Array.isArray(tour?.nodes) ? tour.nodes : [];
  const nodeOrigin =
    nodes.find((node) => `${node?.type || node?.role || ''}`.toLowerCase() === 'origin') ||
    nodes[0] ||
    null;
  const directOrigin =
    tour.originNode || tour.origin || tour.start || tour.startLocation || null;
  const firstCheckpoint =
    Array.isArray(tour?.checkpoints) && tour.checkpoints.length
      ? tour.checkpoints[0]
      : Array.isArray(derivedCheckpoints) && derivedCheckpoints.length
        ? derivedCheckpoints[0]
        : null;

  return (
    toLatLngOrNull(originNode) ||
    toLatLngOrNull(tour?.originNode) ||
    toLatLngOrNull(directOrigin) ||
    toLatLngOrNull(nodeOrigin) ||
    toLatLngOrNull(firstCheckpoint) ||
    null
  );
};

export default resolveTourStartLatLng;
